import useLocalStorage from '@based/use-local-storage'

const SESSION_KEY = 'esc_analytics_session'

export const useSession = () => {
  return useLocalStorage<string | null>(SESSION_KEY, null)
}
